import { render } from "./ETrailer.vue?vue&type=template&id=ed856c36&scoped=true&lang=true"
import script from "./ETrailer.vue?vue&type=script&lang=js"
export * from "./ETrailer.vue?vue&type=script&lang=js"

import "./ETrailer.vue?vue&type=style&index=0&id=ed856c36&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed856c36"]])

export default __exports__